/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  emptyUploadedMediaFile,
  orderSelector,
  setDisputeMedia,
} from "../../../../../../redux/slices/orderSlice";
import {
  getAllDisputes,
  updateDispute,
} from "../../../../../../api/order/disputes-admin";
import {
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputLabel,
  Tooltip,
} from "@mui/material";
import InputField from "../../../../../../Authentication/components/InputField";
import styles from "../../../../../customer/styles/customerStyles.module.css";
import { Icon } from "@iconify/react";
import axiosProtected from "../../../../../../api/config/baseWithToken";
import { handleFileChange } from "../../../../../customer/pages/orders/utils/checkFIleSizeAndType";
import { toast } from "react-toastify";

export default function UpdateDisputeRequestModalContent({
  disputeId,
  dispute,
}) {
  const isResendOutcome = dispute?.outcome?.[0] === "Resend";
  const [message, setMessage] = useState("");
  const [trackingNumber, setTrackingNumber] = useState("");
  // China ticks this when a new parcel went out; its number then becomes a
  // real shipment (17track, order tracking, tracking page, Shopify)
  const [resendDone, setResendDone] = useState(isResendOutcome);
  const validNumber = /^[A-Za-z0-9-]{6,40}$/.test(trackingNumber.trim());

  const dispatch = useDispatch();
  const { disputeMedia } = useSelector(orderSelector);
  const [fileLink, setFileLink] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [uploadedMediaFile, setUploadedMediaFile] = useState(null);

  const [mediaUploadLoading, setMediaUploadLoading] = useState(false);

  const uploadMedia = async () => {
    const formData = new FormData();
    formData.append("media", fileLink);
    setIsLoading(true);
    try {
      const { data } = await axiosProtected.post(`/store/upload`, formData);
      setIsLoading(false);
      setUploadedMediaFile(data);
      return data;
    } catch (error) {
      console.error("Error uploading media:", error);
      throw error;
    }
  };

  useEffect(() => {
    const handleFileUpload = async () => {
      if (fileLink) {
        dispatch(emptyUploadedMediaFile(null));

        try {
          await uploadMedia();
          setMediaUploadLoading(false);
        } catch (error) {
          console.log(error);
        }
      }
    };

    handleFileUpload();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileLink]);

  useEffect(() => {
    uploadedMediaFile?.media && setMediaUploadLoading(false);
    dispatch(setDisputeMedia([...disputeMedia, uploadedMediaFile?.media]));
    setFileLink(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadedMediaFile?.media]);

  useEffect(() => {
    return () => {
      dispatch(emptyUploadedMediaFile(null)); // Call the function to remove data when component unmounts
    };
  }, []);

  const handleUpdateDispute = () => {
    dispatch(
      updateDispute({
        disputeId: disputeId,
        updateDetails: {
          // status: status,
          message: message,
          response: {
            feedback: message,
            ...(resendDone
              ? { tracking_number: trackingNumber.trim(), resend_done: true }
              : {}),
            files: disputeMedia?.filter((item) => item),
          },
        },
      })
    ).then((action) => {
      const resend = action?.payload?.dispute?.resend;
      if (resend) {
        if (resend.shopify === "updated") {
          toast.success("Resend registered and added to the order in Shopify");
        } else if (resend.shopify === "skipped") {
          toast.info("Resend registered. The order has no Shopify fulfillment to add it to.");
        } else {
          toast.warn(`Resend registered in U-Send. ${resend.errors?.join(" · ") || ""}`);
        }
      }
      dispatch(getAllDisputes({ page: 0, size: 50 }));
      dispatch(setDisputeMedia([]));
    });
  };

  const handleTextFieldKeyDown = (event) => {
    event.stopPropagation();
  };
  return (
    <>
      <h2 className={styles.welcome_popup} style={{ marginBottom: "20px" }}>
        Complete the dispute
      </h2>
      {!isResendOutcome && (
        <>
          <InputLabel sx={{ margin: 0, textAlign: "left", color: "#000" }}>
            Message
          </InputLabel>
          <InputField
            label="Message"
            placeholder="message"
            name="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={handleTextFieldKeyDown}
            type="text"
            size="small"
          />
        </>
      )}
      <FormControlLabel
        sx={{ display: "flex", m: "8px 0 4px" }}
        control={
          <Checkbox
            checked={resendDone}
            onChange={(e) => setResendDone(e.target.checked)}
          />
        }
        label="Resend done: a new parcel was sent"
      />
      {resendDone && (
        <div>
          <InputLabel sx={{ margin: 0, textAlign: "left", color: "#000" }}>
            Tracking number of the resend
          </InputLabel>
          <InputField
            label="Tracking number"
            placeholder="YT…"
            name="trackingNumber"
            value={trackingNumber}
            onChange={(e) => setTrackingNumber(e.target.value)}
            onKeyDown={handleTextFieldKeyDown}
            type="text"
            size="small"
          />
          <p style={{ fontSize: 12, lineHeight: 1.4, margin: "4px 0 12px", color: "#6e6e73" }}>
            Shown on the order, in order tracking and on the tracking page, and added to the order in Shopify.
          </p>
        </div>
      )}
      {!isResendOutcome && (
        <>
          <InputLabel sx={{ margin: 0, textAlign: "left", color: "#000" }}>
            Upload Attachments
          </InputLabel>
          <div
            style={{
              border: "1px dashed lightgray",
              padding: "26px",
              borderRadius: "5px",
              textAlign: "center",
            }}
          >
            <IconButton
              onChange={(e) => {
                handleFileChange(e) === true
                  ? setFileLink(e.target.files[0])
                  : toast.warn(
                      "Invalid file. Please select a file that is within 50MB and of type PNG, JPEG, PDF, or MP4."
                    );
              }}
              aria-label="upload picture"
              component="label"
            >
              <input hidden accept="image/*" type="file" />
              <Icon icon="bi:cloud-upload" width="40" height="40" />
            </IconButton>

            <h6
              style={{ textAlign: "center", fontSize: "12px", lineHeight: 1.5 }}
            >
              Allow file uploads of PNG, JPEG, PDF, and MP4 formats, limited to
              a maximum size of 100MB.
            </h6>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p>
              {mediaUploadLoading
                ? "File uploading..."
                : uploadedMediaFile?.media && disputeMedia?.length > 0
                ? disputeMedia
                    ?.filter((item) => item)
                    .map((item, index) => (
                      <div style={{ marginTop: "5px", display: "flex" }}>
                        <Tooltip
                          componentsProps={{
                            tooltip: {
                              sx: {
                                backgroundColor: "#ffffff",
                                boxShadow:
                                  "rgba(145, 158, 171, 0.2) 0px 0px 2px 0px, rgba(145, 158, 171, 0.35) 0px 12px 24px -4px",
                                color: "black",
                                fontSize: "13px",
                                fontWeight: 500,
                                padding: "15px",
                                textAlign: "left",
                                maxWidth: "450px",
                              },
                            },
                            arrow: {
                              sx: {
                                fontSize: 16,
                                color: "#ffffff",
                              },
                            },
                          }}
                          title={
                            <img
                              src={item}
                              style={{ width: "100%", height: "100%" }}
                              alt="receipt"
                            />
                          }
                          placement="top"
                          arrow
                        >
                          <a
                            href={item}
                            target="_blank"
                            style={{
                              textDecoration: "underline",
                              marginRight: "5px",
                            }}
                            rel="noreferrer"
                          >
                            {`${index + 1} file attached`}
                          </a>
                        </Tooltip>
                      </div>
                    ))
                : "0 File uploaded"}
            </p>
          </div>
        </>
      )}

      {!isLoading ? (
        <Button
          variant="lightblue"
          disabled={
            (resendDone && !validNumber) || (!isResendOutcome && message === "")
          }
          sx={{
            width: "auto",
            borderRadius: "5px",
          }}
          onClick={() => handleUpdateDispute()}
        >
          Complete
        </Button>
      ) : (
        <Button
          variant="lightblue"
          disabled
          sx={{
            width: "auto",
            borderRadius: "5px",
          }}
        >
          Uploading....
        </Button>
      )}
    </>
  );
}
